// GateColorPicker.jsx
import React from "react";

const GateColorPicker = ({ modelParams, setModelParams }) => {
  // Защита от отсутствия данных
  if (!modelParams?.palette || !modelParams?.panels) return null;

  const { palette, panels, activeMaterial } = modelParams;

  const handleChange = (e) => {
    const matName = e.target.value;
    const sourceMaterial = palette[matName];

    if (!sourceMaterial) return;

    // Один клон на все панели
    const clonedMaterial = sourceMaterial.clone();
    clonedMaterial.userData.isPickerClone = true;

    // Предыдущий клон освобождаем, чтобы не копились материалы в памяти GPU
    const prevMaterial = panels[0]?.material;

    // Применяем клон ко всем панелям
    panels.forEach((mesh) => {
      mesh.material = clonedMaterial;
    });

    if (prevMaterial?.userData?.isPickerClone) prevMaterial.dispose();

    // Обновляем состояние (опционально, но безопасно)
    if (typeof setModelParams === "function") {
      setModelParams((prev) => ({
        ...prev,
        activeMaterial: matName,
      }));
    }
  };

  return (
    <>
      <p style={{ color: "white" }}>Цвет панелей</p>
      <select
        value={activeMaterial || ""}
        onChange={handleChange}
        style={{
          padding: "6px",
          margin: "4px",
          borderRadius: "4px",
          fontSize: "14px",
        }}>
        {/* <option value="">Цвет панелей</option> */}
        {Object.keys(palette).map((name) => (
          <option key={name} value={name}>
            {name.replace("панель_", "").replace(/_/g, " ")}
          </option>
        ))}
      </select>
    </>
  );
};

export default GateColorPicker;
